import request from "../../utils/api";

//get manage content
export const getManageContent = params => {
  return request("v1/cms/get-manage-content", {
    body: params
  });
};

export const createReservation = params => {
  const { propertyCode, unitNumber, buildingCode } = params;

  return request(
    `v1/sellers/properties/${propertyCode}/buildings/${buildingCode}/units/${unitNumber}/reservation`,
    {
      method: "post",
      body: params.body
    }
  );
};

export const confirmReservation = params => {
  const { propertyCode, unitNumber, buildingCode } = params;
  
  let propCode = propertyCode

  if (propertyCode === undefined || propertyCode === null){
    propCode = params.body.rno
    propCode = propCode.split('=')[1];
    
  }
  return request(
    `v1/sellers/properties/${propCode}/buildings/${buildingCode}/units/${unitNumber}/reservation/confirmed`,
    {
      method: "post",
      body: params.body
    }
  );
};
